var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntercomDefault = function SvgIntercomDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24 44c11 0 20-9 20-20S35 4 24 4 4 13 4 24s9 20 20 20z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF"
    },
    fill: "#FFF",
    d: "M23.2 31H15c-.6 0-1-.5-1-1V17c0-.6.4-1 1-1h18c.6 0 1 .5 1 1v13c0 .6-.4 1-1 1h-5v4l-4.8-4z"
  })));
};
export default SvgIntercomDefault;